import Link from 'next/link'

import type { SignoffPrimary } from '@/journey/_lib/compose-stand'

// Subordinate CTA line beneath the paragraph. Right-aligned, set in the running
// serif so it reads as the entry's signature, not as a button. The arrow is the
// second (and last) vermilion placement at rest. When `primary` is null
// (resting / edition-complete), nothing renders — the paragraph carries the state.
export function SignoffLine({ primary }: { primary: SignoffPrimary | null }) {
    if (!primary) return null

    const trailing =
        primary.lessonNumber !== null
            ? `Lesson ${String(primary.lessonNumber).padStart(2, '0')} · ${primary.pathLabel}`
            : primary.pathLabel
    const ariaLabel = trailing ? `${primary.verb} — ${trailing}` : primary.verb

    return (
        <footer className="mt-10 flex justify-end sm:mt-12 lg:mt-14">
            <Link
                href={primary.href}
                aria-label={ariaLabel}
                className="group/cta inline-flex items-baseline gap-2 rounded-sm font-serif text-base text-ink italic underline-offset-4 outline-focus-ring transition-colors hover:text-action hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 motion-reduce:transition-none sm:text-lg"
            >
                <span>{primary.verb}</span>
                {/* reason: vermilion #2 — the CTA arrow, the entry's chromatic pull.
                    Embedded in the line, not in a fill, so chromatic mass stays at
                    seal-scale. Step-advance translate fires only on hover (≤1 motion at rest). */}
                <span
                    aria-hidden
                    className="inline-block text-action transition-transform duration-300 ease-out group-hover/cta:translate-x-1 motion-reduce:transform-none motion-reduce:transition-none"
                >
                    →
                </span>
                {trailing && <span className="not-italic">{trailing}</span>}
            </Link>
        </footer>
    )
}
